export default {
    data() {
        return {
            historialTable: [
                { fecha: '2021-01-15', valor: 50000, sms: 150 },
                { fecha: '2021-02-28', valor: 150000, sms: 200 },
                { fecha: '2021-04-16', valor: 250000, sms: 500 },
                { fecha: '2021-06-21', valor: 350000, sms: 800 }
            ],
        }

    },
}